module.exports = __webpack_public_path__ + "static/media/Koch Ag & Energy Solutions.c1723621.svg";